import React from "react";
import { Grid } from "@mui/material";
import PrintRegCloseSummary from "./PrintRegCloseSummary";
import { formatDate, PrintDiv } from "../../../../../hooks/Method";
import { Button } from "../../../../../controls";

const CloseRegDtls = ({ activeReg, txns, totals }) => {
  const handlePrintLastReceipt = () => {
    PrintDiv("printRegCloseSummary");
  };

  return activeReg ? (
    <>
      <div className="d-none" id="printRegCloseSummary">
        {activeReg && activeReg.status === 2 && (
          <PrintRegCloseSummary {...{ data: activeReg, txns, totals }} />
        )}
      </div>

      <div className="bg-white rounded-[20px]">
        <div className="!mb-[15px] flex flex-wrap gap-2 justify-between items-center pb-[5px] p-[10px] border-b">
          <div>
            <span className="text-[20px] tracking-wide font-medium text-gray-500 border-left">
              Last Closer Details
            </span>
          </div>

          <Button
            onClick={handlePrintLastReceipt}
            variant="text"
            className="max-sm:w-full"
          >
            Print Last Summary
          </Button>
        </div>

        <Grid container spacing={2} className="p-[15px]">
          <Grid item xs={12} md={3} className="d-grid">
            <span className="text-[11px]  uppercase mb-[5px] text-gray-400">
              Outlet
            </span>
            <span className="text-[16px] text-gray-500 font-medium">
              {activeReg.outlet ? activeReg.outlet.outletName : ""}
            </span>
          </Grid>
          <Grid item xs={12} md={3} className="d-grid">
            <span className="text-[11px]  uppercase mb-[5px] text-gray-400">
              Register
            </span>
            <span className="text-[16px] text-gray-500 font-medium">
              {activeReg.register ? activeReg.register.name : ""}
            </span>
          </Grid>
          <Grid item xs={12} md={3} className="d-grid">
            <span className="text-[11px]  uppercase mb-[5px] text-gray-400">
              Opening time
            </span>
            <span className="text-[16px] text-gray-500 font-medium">
              {formatDate(activeReg.openingTime)}
            </span>
          </Grid>

          <Grid item xs={12} md={3} className="d-grid">
            <span className="text-[11px]  uppercase mb-[5px] text-gray-400">
              Closing time
            </span>
            <span className="text-[16px] text-gray-500 font-medium">
              {formatDate(activeReg.closingTime)}
            </span>
          </Grid>
        </Grid>
      </div>
    </>
  ) : (
    ""
  );
};

export default CloseRegDtls;
